import { useTranslation } from 'react-i18next'

const HomophobicAdultEnd = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="homophobic-adult-start-title"
      {...props}
    >
      <title id="homophobic-adult-end-title">{t('antagonists:homophobicAdult:components:end')}</title>
      <defs>
        <clipPath id="homophobic-adult-end-a">
          <path
            d="M1431.98 474.48s-5.34 42.05 46.35 47.09c51.69 5.04 63.21-9.36 69.52-27.63 6.31-18.28-4.46-32.09-4.46-32.09l90.93 51.09s-51.69 187.86-43.49 262.86c8.19 75.02 41.61 115.36 42.86 180.92 1.27 65.56 11.35 276.73 11.35 276.73s-84.47 17.01-165.8 20.18c-119.78 4.67-241.68-58.19-241.68-58.19s33.66-98.16 51.3-185.15c17.66-86.99 56.11-216.85 60.52-264.77s3.15-265.38 3.15-265.38l76.27-8.83 3.15 3.15.02.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
      </defs>
      <path
        d="M1527.85 265.26c-5.41-2.43-19.12-22.75-52.46-12.25-41.91 13.18-29.22 30.79-44.92 41.17-15.7 10.36-31.25 28.3-27.47 44.96s12.71 37.68 9.55 48.36c-3.14 10.68 4.6 26.36 23.44 42.08 18.86 15.7 32.48 28.92 67.04 32.07 34.56 3.14 13.41-21.38 22.59-18.49 13.76 4.34 30.52 3.08 33.4-4.78 1.96-5.34-9.45-8.83 8.42-24.81 7.95-7.12 19.9-10.17 27.44-27.46 7.54-17.29 2.41-31.62-5.76-55.18s-11-38.65-27.02-49.33-27.97-13.52-34.24-16.34v-.02Z"
        style={{
          fill: '#eaeaea',
        }}
      />
      <path
        d="M1444.9 414.11s8.55 24.23 2.1 32.25-25.8 16.9-25.8 16.9-4.71 77.22-4.35 76.52 144.84 3.84 144.84 3.84-2.57-61.89-3.97-61.36-11.38-19.16-19.23-30.84c-7.84-11.68 2.78-32.25 2.78-32.25l-96.4-5.06h.02Z"
        style={{
          fill: '#e9b97d',
        }}
      />
      <path
        d="M1510.12 307.15c-20.42-2.78-33.2-12.94-45.45-6.34-12.25 6.59-21.68 11.63-21.06 23.88.63 12.25 1.25 30.79-3.14 36.44-4.41 5.66-10.86 5.67-17.15 6.61s-8.93 5.96-6.73 23.86 9.16 27.76 13.52 28.9c6.66 1.74 6.91-3.14 8.48-1.57s3.45 15.09 12.25 24.81c8.79 9.75 24.51 20.11 37.08 20.74 12.57.63 39.9-3.14 47.76-10.36 7.86-7.23 12.88-23.56 15.7-22.63s2.82 7.54 11.63-3.45c8.79-11 15.65-29.87 13.13-34.59s-11.56-.92-13.13-8.46c-1.57-7.54-6.91-29.22-4.09-40.85 2.82-11.63 5.34-20.11-5.66-32.06-11-11.93-29.32-3.08-43.14-4.97v.04Z"
        style={{
          fill: '#e9b97d',
        }}
      />
      <path
        d="M1514.42 335.56c5.99.56 23.4 1.04 27.14 5.87s7.12 12.86 7.12 12.86l-2.31 1.16s-4.12-8.76-10.2-11-21.71-3.12-21.71-3.12v-5.8l-.04.02ZM1487.46 339.9l1.37-5.64s-24.06-2.38-29.22.32c-5.15 2.7-9.29 9.69-9.29 9.69l1.92 2.04s6.66-7.86 11.4-8.02 23.81 1.59 23.81 1.59v.02Z"
        style={{
          fill: '#d5d6d7',
        }}
      />
      <path
        d="m1523.36 367.34 9.59 3.14.69-3.31-10.61-4.28s.07 4.42.33 4.46Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1524.04 363.3c2.66 1.83 3.3 4.92 1.41 7.45-1.9 2.54-5 2.57-7.49 1.07-2.94-1.76-3.54-4.51-1.85-7.33 1.18-1.99 5.2-3.1 7.95-1.22l-.02.02ZM1471.37 361.92l-10.31 2.41-1.07-3.51 11.75-3.21s-.09 4.34-.37 4.3Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1470.17 358.26c-2.63 1.87-3.22 4.97-1.29 7.47 1.94 2.5 5.06 2.56 7.51 1.02 2.91-1.82 2.77-4.88 1.04-7.67-1.22-1.96-4.56-2.77-7.28-.85l.02.02Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1565.18 357.78s-15.86-7.44-34.24-7.81c-19.84-.41-21.06 5.02-24.16 6.8-1.94 1.11-2.33.32-6.64-.09-4.34-.41-4.83.55-6.61-.81-2.84-2.19-3.3-7.72-23.02-10.03-18.26-2.13-34.65 3.74-34.65 3.74l-.92 5.32s4.23.99 4.99 9.23c.76 8.25 1.36 17.9 24.43 19.9s26.65-8.9 28.3-13.15c1.96-4.99 2.45-8.04 4.14-8.42 1.07-.25 5.25-.41 6.29 0 1.62.6 1.25 4.11 2.5 9.3 1.06 4.44 2.7 15.56 25.8 16.72 23.12 1.16 25.47-8.18 27.35-16.25 1.89-8.07 6.49-7.19 6.49-7.19l-.04-7.28h-.02Zm-88.19 20.95c-9.76 2.66-25.2.37-29.73-6.43-3.67-5.5-3.81-11.05-3.65-16.18.18-5.94 11.67-6.66 24.3-6.12s21.52 4.18 21.11 13.57c-.41 9.39-4.69 13.15-12.04 15.14v.02Zm71.78.95c-6.04 3.51-13.99 5.04-26.66 1.71-9.69-2.56-12.65-7.68-11.75-17.04.88-9.36 9.99-11.07 22.58-9.89s23.05 3.35 21.96 10.66c-.78 5.06-.55 11.33-6.12 14.56Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="M1468.23 416.06c-.6 2.36 2.31 8.62 7.01 10.71 4.71 2.1 6.1 5.92 15 6.27 8.88.35 13.02-2.17 16-2.96 2.64-.7 10.24-4.62 10.06-6.71-.19-2.36-4.67-5.2-10.06-5.73s-12.85 1.71-14.59 1.53-5.06-3.97-11.17-4.6c-6.78-.7-11.12-3-12.23 1.48h-.02Z"
        style={{
          fill: '#f1958d',
        }}
      />
      <path
        d="M1211.98 597.42s22.06 43.49 49.8 61.15c27.74 17.66 87.62 66.83 89.51 72.5s.63 13.87 1.89 22.06c1.25 8.19-6.93 23.95-15.75 32.78s-11.98 17.02-19.54 11.98-4.41-13.87-8.19-23.95c-3.79-10.08-13.23-25.22-19.54-27.74-6.31-2.52-44.13-18.91-76.91-40.34-32.78-21.43-78.18-70.6-75.02-80.06s4.41-26.47 20.8-38.45c16.39-11.98 49.8-1.89 52.96 10.08l.02-.02ZM1729.53 645.95s-10.08 32.14-39.09 51.69c-28.99 19.54-31.09 24.27-46.65 31.53-15.56 7.24-38.45 11.98-41.61 19.54-3.15 7.56-.63 18.28-.63 28.99s7.56 30.89 15.12 34.66c7.56 3.79 16.39-.63 25.22-10.71 8.83-10.08 13.23-18.91 24.58-22.7s71.23-30.26 97.08-56.11c25.85-25.85 35.19-40.46 35.19-56.23s-.53-34.54-25.11-39.6c-24.58-5.06-44.13 18.91-44.13 18.91l.02.04Z"
        style={{
          fill: '#e9b97d',
        }}
      />
      <path
        d="M1431.98 474.48s-5.34 42.05 46.35 47.09c51.69 5.04 63.21-9.36 69.52-27.63 6.31-18.28-4.46-32.09-4.46-32.09l90.93 51.09s-51.69 187.86-43.49 262.86c8.19 75.02 41.61 115.36 42.86 180.92 1.27 65.56 11.35 276.73 11.35 276.73s-84.47 17.01-165.8 20.18c-119.78 4.67-241.68-58.19-241.68-58.19s33.66-98.16 51.3-185.15c17.66-86.99 56.11-216.85 60.52-264.77s3.15-265.38 3.15-265.38l76.27-8.83 3.15 3.15.02.02Z"
        style={{
          fill: '#00a39a',
        }}
      />
      <g
        style={{
          clipPath: 'url(#homophobic-adult-end-a)',
        }}
      >
        <path
          d="M1377.61 489.92c0 3.75 33.8 63.85 110.16 68.85s128.93-63.85 128.93-63.85l3.75-80.11-239.09-1.25-3.75 76.36Z"
          style={{
            fill: '#006443',
          }}
        />
      </g>
      <path
        d="M1448.34 443.47s-4.48 7.56-6.4 26.86c-1.36 13.73-.23 29.17 2.66 51.44 6.93 53.59 13.87 156.97 18.91 187.86 5.04 30.89-8.83 187.86-8.83 187.86s-38.42 5.2-87.59-10.57c-49.17-15.75-59.94-27.88-59.94-27.88s10.08-63.04 20.8-85.74c10.71-22.7 10.71-55.48 3.79-83.22-6.93-27.74-23.49-75.16-23.49-75.16s-10.87-135.84 29.47-142.76c40.34-6.93 74.6-7.31 82.79-10.47s27.81-18.22 27.81-18.22h.02ZM1538.16 451.47s28.11 59.58 1 142.16c-27.1 82.58-17.8 113.35-21.59 165.67s-1.89 139.31-1.89 139.31 37.64 6.04 66.65 1.62c29.01-4.42 57.13-13.34 57.13-13.34s-9.39-25.15-16.51-55.85c-4.99-21.45-19.09-51.9-15.7-68.48 8.19-40.34 46.65-76.27 54.21-119.15 7.56-42.86 20.69-115.08-8.32-131.47-28.99-16.39-65.19-28.44-79.69-35.39-14.5-6.93-35.28-25.11-35.28-25.11l-.02.02Z"
        style={{
          fill: '#71ae52',
        }}
      />
      <path
        d="M1334.91 472.6c-22.43 3.93-73.75 55.48-110.32 72.5-36.57 17.02-95.97 55.9-94.09 76.08 1.89 20.18 55.12 78.44 55.12 78.44s20.14-9.18 33.99-18.66c16.04-10.98 31.33-31.33 31.33-31.33s-10.59-10.59 1.37-15.63c11.97-5.04 42.24-11.35 70.6-18.91 28.37-7.56 60.52-49.8 57.36-96.45-3.15-46.65-20.18-50.44-45.38-46.01v-.02ZM1638.75 509.17c-27.21 5.73-10.71 144.35 13.23 147.5 23.95 3.15 61.89 8.93 61.26 14.61-.63 5.67-8.76 12.74-8.76 12.74s29.04 18.19 47.34 23.86c18.28 5.67 33.8 11.21 33.8 11.21s27.74-47.28 21.43-66.83c-6.31-19.54-52.31-49.98-87.6-79.62-35.3-29.62-56.75-68.54-80.7-63.48Z"
        style={{
          fill: '#71ae52',
        }}
      />
    </svg>
  )
}

export default HomophobicAdultEnd